import {TRIP_ACTION, PRODUCT_TYPE, BOOKING_STATUS, HOLDING_STATUS, PAYMENT_STATUS} from './../constants/trip-options';
import appCONST from './../../../constants/app.constants';

export default function TripOptionsService(
    $q,
    $http,
    tripAPI
) {
    'ngInject';

    const emptyDropdownListItem = {text: '---', value: null};
    let callingCodes = [];
    let countries = [];

    Object.assign(this, {
        TRIP_ACTION,
        PRODUCT_TYPE,
        BOOKING_STATUS,
        HOLDING_STATUS,
        PAYMENT_STATUS,

        adultTravellerTitles: [],
        childTravellerTitles: angular.copy(childTravellerTitles()),

        initAdultTitles,
        initCallingCodes,
        initCountries,

        getGenders,
        getCallingCodes,
        getCountries,
        getDropdownLists,
        sentAlert,
        getAdultTitles,
    });

    let initAdultsTitlesPromise = null;
    function initAdultTitles() {
        if (initAdultsTitlesPromise) {
            return initAdultsTitlesPromise;
        }
        initAdultsTitlesPromise = getAdultTitles()
            .then((titles) => this.adultTravellerTitles = titles)
            .catch((error) => {
                initAdultsTitlesPromise = null;
                return $q.reject(error);
            });
        return initAdultsTitlesPromise;
    }

    function getAdultTitles() {
        return $http.get(`${appCONST.apiUrl}/staticdata/GetTitles`, {cache: true})
            .then(({data}) => [
                angular.copy(emptyDropdownListItem),
                ...data.map(({id, name, gender, isSupportedByLowCostAirlines, isSupportedByTrainline}) => ({
                    text: name,
                    value: id,
                    gender,
                    isSupportedByLowCostAirlines,
                    isSupportedByTrainline,
                })),
            ]);
    }

    let initCallingCodesPromise = null;
    function initCallingCodes() {
        if (initCallingCodesPromise) {
            return initCallingCodesPromise;
        }
        initCallingCodesPromise = tripAPI.fetchCallingCodes()
            .then((response) => {
                callingCodes = _.map(response, (code) => ({text: code, value: code}));
                callingCodes.unshift(angular.copy(emptyDropdownListItem));
                return callingCodes;
            })
            .catch((error) => {
                initCallingCodesPromise = null;
                return $q.reject(error);
            });

        return initCallingCodesPromise;
    }

    let initCountriesPromise = null;
    function initCountries() {
        if (initCountriesPromise) {
            return initCountriesPromise;
        }
        initCountriesPromise = tripAPI.fetchCountries()
            .then((response) => {
                countries = _.map(response, (item) => ({text: item.CountryName, value: item.IsoCode}));
                countries.unshift(angular.copy(emptyDropdownListItem));
                return countries;
            })
            .catch((error) => {
                initCountriesPromise = null;
                return $q.reject(error);
            });

        return initCountriesPromise;
    }

    function getGenders() {
        return [
            angular.copy(emptyDropdownListItem),
            {text: 'Male', value: 1},
            {text: 'Female', value: 2},
        ];
    }

    function getCallingCodes() {
        return callingCodes;
    }

    function getCountries() {
        return countries;
    }

    /**
     * Lists for dropdowns
     */
    function getDropdownLists() {
        return {
            adultTravellerTitles: angular.copy(this.adultTravellerTitles),
            childTravellerTitles: childTravellerTitles(),
            genders: angular.copy(this.getGenders()),
            callingCodes: angular.copy(this.getCallingCodes()),
            countries: angular.copy(this.getCountries()),
        };
    }

    //TODO: localize this properties if needed
    function childTravellerTitles() {
        return [
            angular.copy(emptyDropdownListItem),
            {text: 'Mr', value: 1},
            {text: 'Miss', value: 2},
        ];
    }

    function sentAlert() {
        return {
            visible: false,
            type: 'success',
            msg: '',
            show: function(isShow, type, msg) {
                this.visible = isShow;
                this.type = (type) ? type : this.type;
                this.msg = (msg) ? msg : this.msg;
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/services/trip-options-service.js